import React from 'react'
import { HiddenContainer, Container, Box, Divider } from './styles'
import { isValidValue } from '../../../../../../../shared/utils/validates'
import { Grid } from '@material-ui/core'
import logoTmovPay from '../../../../../../../shared/assets/images/logoTmovPayGreen.svg'
import { format } from 'date-fns'
import { TextBoleto } from '../../../../PagamentoBoleto/components/DetalhePagamentoBoleto/styles'
import { colors } from '../../../../../../../shared/styles/colors'
import {
  cnpjMask,
  cpfMask,
  numberToCurrency,
} from '../../../../../../../shared/utils/formatters'
import { useCartao } from '../../../../../hooks/useCartao'
import { useComprovante } from 'modules/pagamentos/hooks/useComprovante'

interface ComprovanteTransferenciaTEDProp {
  protocolo?: string
}
// eslint-disable-next-line react/display-name
const ComprovanteTransferenciaTED = React.forwardRef<
  React.ReactElement,
  React.PropsWithChildren<ComprovanteTransferenciaTEDProp>
>((props, ref) => {
  const { transferenciaTED } = useComprovante()
  const { cartao } = useCartao()

  return (
    <HiddenContainer>
      {isValidValue(transferenciaTED) && (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Container ref={ref}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  textAlign: 'center',
                }}
              >
                <Grid item xs={12}>
                  <img src={logoTmovPay} height={40} />
                </Grid>
                <Grid item xs={12}>
                  <TextBoleto
                    $fontSize={'18px'}
                    $fontWeight={'700'}
                    $color={colors.gray1}
                  >
                    Comprovante de transferência
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'14px'}
                    $fontWeight={'400'}
                    $color={colors.gray}
                  >
                    {format(new Date(), 'dd/MM/yyyy H:mm:ss')}
                  </TextBoleto>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  margin: 16,
                }}
              >
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Detalhes
                    </TextBoleto>
                  </Grid>
                </Box>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Valor
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(transferenciaTED?.valor ?? 0)}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Tipo
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    TED - Conta bancária
                  </TextBoleto>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Destino
                    </TextBoleto>
                  </Grid>
                </Box>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Favorecido
                    </TextBoleto>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    style={{
                      marginBottom: 8,
                    }}
                  >
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {transferenciaTED.nomeBeneficiarioDestino}
                    </TextBoleto>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    style={{
                      marginBottom: 8,
                    }}
                  >
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Documento
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {transferenciaTED.documentoDestino?.length === 11
                        ? cpfMask(transferenciaTED.documentoDestino)
                        : cnpjMask(transferenciaTED.documentoDestino)}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Banco
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {transferenciaTED.bancoDestino?.nome}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Agência
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {`${transferenciaTED.agenciaNumeroDestino} -
                        ${transferenciaTED.agenciaDigitoDestino}`}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Conta
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {`${transferenciaTED.contaNumeroDestino} -
                        ${transferenciaTED.contaDigitoDestino}`}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Tipo
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {transferenciaTED.contaTipoDestino}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Pagador
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Nome
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao.titular}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      {isValidValue(cartao?.conta) ? 'Conta' : 'Cartão'}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao?.conta ?? cartao?.identificador}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Meio de pagamento
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      TMOV Pay
                    </TextBoleto>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </HiddenContainer>
  )
})

export default ComprovanteTransferenciaTED
